import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import {
    Dic
} from "@src/common/utils";
const tableOption = function () {
    let status = Dic.find("SENU080001");
    return {
        view: "预约详情",
        page: true,
        selection: true,
        index: true,
        indexLabel: "序号",
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: true,
        editBtn: false,
        delBtn: false,
        align: "left",
        size: "small",
        maxHeight: "100%",
        labelWidth: "100px",
        menuAlign: "center",
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 400,
        dialogWidth: "700px",
        emptyText: "暂无数据",
        column: [

            // {
            //     label: "来访编号",
            //     prop: "visitCode",
            // },
            // {
            //     label: "接待人",
            //     prop: "visitorReceiverName",

            // },
            // {
            //     label: "来访人数",
            //     prop: "visitorsNumber",
            //     width: 100,
            // },
            {
                label: "访客姓名",
                prop: "name",
                search: true
            },
            {
                label: "访问部门",
                prop: "receiverDepartmentNames",
            },
            {
                label: "电话号码",
                prop: "phone",
                width: 140
            },
            {
                label: "接待人",
                prop: "receiverNames",

            },
            {
                label: "来访目的",
                prop: "visitorReason",
            },
            {
                label: "入厂时间",
                prop: "enterTime",
            },
            {
                label: "出厂时间",
                prop: "exitTime",


            },
            // {
            //     label: "创建人",
            //     prop: "creator",

            // },
            {
                label: "登记时间",
                prop: "createTime",
                search: true,
                searchSlot: true
            },
            {
                label: "审批结果",
                prop: "status",
                dicData: Dic.find('SENU080001'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU080001', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU080001', value) : ''
                },

            },

        ],
    };
};
export default tableOption;